import { Injectable, signal } from '@angular/core';
import { defaultTreeOptions } from '@app/orders/models/dx-tree-list.model';
import { TableFilterResult } from '@shared/models/table-filter.model';

@Injectable()
export class OrdersTreeListStore {
  readonly currentPage = signal(1);
  readonly pageSize = signal(0);
  readonly categoryTooltip = signal<string>('');
  readonly rateTooltip = signal<string>('');
  readonly pendingSelectionRestore = signal<number[] | null>(null);
  readonly expandedKeys = signal<ReadonlySet<number>>(new Set<number>());
  readonly lastFilters = signal<TableFilterResult[]>([]);
  readonly lastValidPageSize = signal<number>(defaultTreeOptions.pagination.pageSize);
  readonly isPageSizeChanging = signal(false);
  readonly isPageChanging = signal(false);
}
